import API from './API';
import config from '../config';

const api = new API();
const a = navigator.userAgent || navigator.vendor || window.opera;

const helpers = {
    /**
     * Gets the top Miniplayer object
     * @param  {Component} _callingObj React component which is calling this function
     * @param  {number} depth       Number the define the depth of search quest
     * @return {Miniplayer}         Root Miniplayer component
     */
    getMiniplayer: (_callingObj, depth) => {
        let ret = false;
        if (depth > 100) {
            throw new Error('No Miniplayer found!');
        } else {
            let obj;
            if (depth > 0) {
                obj = _callingObj;
            } else {
                obj = _callingObj._reactInternalFiber;
            }

            if (
                obj &&
                obj.return &&
                obj.return.stateNode &&
                obj.return.stateNode.NPOlabels
            ) {
                ret = obj.return.stateNode;
            } else {
                ret = helpers.getMiniplayer(obj.return, depth ? depth + 1 : 1);
            }
        }
        return ret;
    },

    isMobile:
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4)
        ),

    encodeQueryData(data) {
        const ret = [];
        Object.keys(data).forEach(d => {
            ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
        });
        return ret.join('&');
    },

    channelInfo: {},

    getChannelInfo(channel) {
        if (!channel) {
            throw new Error('No channel was given');
        }

        return new Promise((resolve, reject) => {
            let tries = 0;
            const maxTries = 20;
            const interval = window.setInterval(() => {
                tries += 1;
                if (helpers.channelInfo[`_${channel}`]) {
                    clearInterval(interval);
                    resolve(helpers.channelInfo[`_${channel}`]);
                }
                if (tries >= maxTries / 2) {
                    // Maybe channelInfo isn't loaded
                    helpers.loadChannelInfo(channel);
                }
                if (tries >= maxTries) {
                    // Consider unreachable after maxTries tries
                    clearInterval(interval);
                    reject(
                        new Error(
                            `Channel info unreachable after ${maxTries} tries`
                        )
                    );
                }
            }, 17);
        });
    },

    loadChannelInfo(channel) {
        if (!channel || !config[channel]) {
            return;
        }

        const channelInfo = {
            name: config[channel].name,
            website: config[channel].websiteUrl,
            videoplayer: config[channel].liveUrl
        };

        if (config[channel].audioStream) {
            channelInfo.audiostream = config[channel].audioStream;
        }

        helpers.channelInfo[`_${channel}`] = channelInfo;
    },

    getPlayer(playerElmId) {
        let mediaContainer;

        if (playerElmId) {
            mediaContainer = document.getElementById(playerElmId);
        } else {
            const npoPlayer = document.getElementById('NpoPlayer');
            [mediaContainer] = npoPlayer.getElementsByClassName(
                'media-container'
            );
        }

        const iframe = mediaContainer.getElementsByTagName('iframe')[0];

        if (iframe.contentWindow) {
            return iframe.contentWindow;
        }
        throw new Error('No iframe contentWindow in NpoPlayer');
    },

    getTrackStyleCSS(
        prefixes,
        { trackLowerFill, trackLowerFillGradient, trackColor, currentValue }
    ) {
        let style = '';

        if (
            trackLowerFill &&
            trackLowerFillGradient &&
            trackColor &&
            currentValue
        ) {
            prefixes.forEach(prefix => {
                style += `.VolumeControl input[type=range]::-${prefix}{background:linear-gradient(to right, ${trackLowerFill} 0%, ${trackLowerFillGradient} ${currentValue *
                    1}%, ${trackColor} ${currentValue}%, ${trackColor} 100%)}`;
            });
        }

        return style;
    },

    api
};

export default helpers;
